import type { ConfigureProps as BaseConfigureProps } from 'react-instantsearch';
import { Configure as BaseConfigure } from 'react-instantsearch';

import { useRouter } from '@/hooks/useRouter';
import { HITS_PER_PAGE } from '@/lib/const';

export const Configure = (props: Partial<BaseConfigureProps>) => (
  <BaseConfigure
    analytics
    clickAnalytics
    enablePersonalization
    userToken={undefined} // TODO: Add token here in the future to track users' activity
    {...props}
  />
);

export const PaginatedConfigure = (props: Partial<BaseConfigureProps>) => {
  const { query } = useRouter();
  const page = Number(query.page);

  if (page) {
    return (
      <Configure hitsPerPage={HITS_PER_PAGE * page} offset={0} {...props} />
    );
  }

  return <Configure hitsPerPage={HITS_PER_PAGE} {...props} />;
};
